import { z } from 'zod';

/**
 * A user the MO and reporting-manager searches find. Only what the pickers show
 * is read, so a null elsewhere in the row cannot fail the whole list.
 */
export const pcmpLookupUserSchema = z.object({
  id: z.coerce.number(),
  /** "Name (HR id)": what the pickers show. */
  text: z.string(),
  designation: z.string().nullish(),
  /** The MO's region. */
  department: z.string().nullish(),
  /** false for a user who left: still listed so their proposals stay filterable (LB-1202). */
  isActive: z.boolean().default(true),
});

export type PcmpLookupUser = z.infer<typeof pcmpLookupUserSchema>;

export const pcmpLookupUsersSchema = z.array(pcmpLookupUserSchema);

/** A region department with its PCMP division (a plain code: a new division must not break the list). */
export const pcmpLookupDepartmentSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  divisionCode: z.string().nullish(),
});

export type PcmpLookupDepartment = z.infer<typeof pcmpLookupDepartmentSchema>;

export const pcmpLookupDepartmentsSchema = z.array(pcmpLookupDepartmentSchema);

/** Which search: the MOs, or the people MOs report to. */
export type PcmpLookupUserKind = 'mos' | 'reportingUsers';
